import { AfterViewInit, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { AgEditorComponent } from "ag-grid-angular";

@Component({
  selector: "ag-grid-datepicker-editor",
  template: `<div #container tabindex="0">
    <input type="text" bsDatepicker [(bsValue)]="dataValue" />
  </div>`,
  standalone: false,
})
export class DatepickerEditor implements AfterViewInit, AgEditorComponent {
  @ViewChild("container", { read: ViewContainerRef }) public container;
  dataValue: Date;

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
    window.setTimeout(() => {
      this.container.element.nativeElement.focus();
    });
  }

  getValue() {
    return this.dataValue;
  }

  isPopup?(): boolean {
    return false;
  }

  agInit(params: any): void {
    this.dataValue = params.value;
  }

  refresh(params: any) {
    return true;
  }
}
